<div class="terms-bg" (click)="onClose()" *ngIf="showTerms"></div>

<div [hidden]="!showTerms" class="terms" [@popup]="{value: showTerms ? 'open' : 'closed'}" id="terms"  role="dialog" aria-label="terms and conditions popup">
  <div class="terms-container" tabindex="0">
    <h2>
      <span [innerHtml]="'TERMS.HEAD' | translate"></span>
    </h2>

    <div class="terms-content" >

      <p [innerHtml]="'TERMS.DESC' | translate"></p>

    </div>

    <div tabindex="0" class="terms-close closeImg" (click)="onClose()" (keydown)="($event.key === 'Enter') && onClose()" aria-label="close terms and conditions popup" role="button"></div>
  </div>
</div>